import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEditWishListParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/wishList/trackEditWishList";

const useTrackEditWishList = (
    parameters: TrackEditWishListParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.editWishList, parameters, options);
};

export default useTrackEditWishList;
